import Config from '@/config.js'
import store from '@/store'
if (!store.state.config.apiurl) {
  store.commit('storeConfig', Config)
}
var engine = {
  headers: function (server) {
    if (server === 'erp') {
      return new Headers({
        Authorization: Config.apikey,
        'Content-Type': 'application/json',
      })
    }
     if (server === 'api') {
      return new Headers({
        'Content-Type': 'application/json',
        Authorization: Config.apikey,
      })
    }
    return new Headers({
      Authorization: 'Bearer ' + store.state.auth.accessToken,
      'Content-Type': 'application/json',
    })
  },

  // start sync function
  synctable (table) {
    const url = Config.apiurl + 'synctable/' + table
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },

  check_alert () {
    const url = Config.apiurl + '/checkAlert'
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('api'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_anagrafica (codcli) {
    const url = Config.apiurl + `/secure/get_anacli/${codcli}`
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_destinatari (codsog) {
    const url = Config.apiurl + `/secure/get_destinatari/${codsog}`
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_puntiDisponibili (codcli) {
    const url = Config.apiurl + `/secure/get_puntiDisponibili/${codcli}`
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_dettaglio_punti (codcli) {
    const url = Config.apiurl + `/secure/get_dettaglio_punti/${codcli}`
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_spareparts (linea) {
    const url = Config.apiurl + `/secure/get_spareparts/${linea}`
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  // riepilogo_ordQta (codcli) {
  //   console.log(Config)
  //   const url = Config.erpurl + '/v2/get_countordini'
  //   var postdata = { codcli: codcli }
  //   const requestOptions = {
  //     method: 'post',
  //     redirect: 'follow',
  //     headers: this.headers('erp'),
  //     body: JSON.stringify(postdata),
  //   }
  //   return new Promise((resolve, reject) => {
  //     fetch(url, requestOptions)
  //       .then((response) => {
  //         return this.handleResponse(response)
  //       })
  //       .then((result) => {
  //         resolve(this.handleResult(result))
  //       })
  //       .catch((error) => {
  //         this.handleError(error, url)
  //         reject(error)
  //       })
  //   })
  // },
  uploadOrder (item) {
    const url = Config.apiurl + '/secure/setOrder'
    const requestOptions = {
      method: 'post',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify(item),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  sendRiparazione (data) {
    const url = Config.apiurl + '/secure/sendRiparazione'
    const requestOptions = {
      method: 'post',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify(data),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },

  // start BLOG function
  getBlogs () {
    const url = Config.apiurl + '/secure/getBlogs'
    const requestOptions = {
      method: 'get',
      redirect: 'follow',
      headers: this.headers('jwt'),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  setBlogs (item) {
    const url = Config.apiurl + '/secure/setBlogs'
    const requestOptions = {
      method: 'post',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify(item),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  delBlogs (item) {
    const url = Config.apiurl + '/secure/delBlogs'
    const requestOptions = {
      method: 'post',
      redirect: 'follow',
      headers: this.headers('erp'),
      body: JSON.stringify(item),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  // end BLOG function
  // get_bslab (linea, modello) {
  //   const url = Config.erpurl + '/get_bslab.php'
  //   const requestOptions = {
  //     method: 'POST',
  //     redirect: 'follow',
  //     headers: this.headers('erp'),
  //     body: JSON.stringify({ linea, modello }),
  //   }
  //   return new Promise((resolve, reject) => {
  //     fetch(url, requestOptions)
  //       .then((response) => {
  //         return this.handleResponse(response)
  //       })
  //       .then((result) => {
  //         resolve(this.handleResult(result))
  //       })
  //       .catch((error) => {
  //         this.handleError(error, url)
  //         reject(error)
  //       })
  //   })
  // },
  get_compo (linea) {
    const url = Config.apiurl + `/secure/get_compo/${linea}`
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },

  get_colcompo (linea) {
    const url = Config.apiurl + `/secure/get_colcompo/${linea}`
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_dittalenti (codcli) {
    const url = Config.apiurl + `/secure/get_dittalenti/${codcli}`
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listalenti (linea) {
    const url = Config.apiurl + `/secure/get_listalenti/${linea}`
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listapromo (linea) {
    const url = Config.apiurl + `/secure/get_listapromo/${linea}`
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listacarnet (linea) {
    const url = Config.apiurl + '/secure/olderListaCarnet'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ anacli: store.state.clidata.anacli, linea }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_archivedOrders (codcli, dataStart, dataEnd) {
    const url = Config.apiurl + '/secure/olderArchiveOrders'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ codcli: codcli, data_start: dataStart, data_end: dataEnd }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_statusOrders (codcli, dataStart, dataEnd, riferimento, tipoRicerca) {
    const url = Config.apiurl + '/secure/olderStatusOrders'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ codcli: codcli, data_start: dataStart, data_end: dataEnd, riferimento: riferimento, tipo_ricerca: tipoRicerca }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_orderDDT (codcli, numbol) {
    var url = Config.apiurl + '/secure/olderOrderDDT'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ codcli: codcli, numbol: numbol }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_listaFatture (codcli, dataStart, dataEnd, riferimento, tipoRicerca) {
    const url = Config.apiurl + '/secure/olderListaFatture'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ codcli: codcli, data_start: dataStart, data_end: dataEnd, riferimento: riferimento, tipo_ricerca: tipoRicerca }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  getOrderToPdf (progre) {
    var url = Config.apiurl + '/secure/getOrderToPdf'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ progre: progre }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  getPdf (order, ver) {
    var url = Config.apiurl + '/getPdf'
    var headers = this.headers('jwt')
    if (ver === 'ordini_v0') {
      url = 'https://swissflex.it/ordini/getPdf.php'
      headers = this.headers('erp')
    }

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: headers,
      body: JSON.stringify({ order: order, pdf: 2 }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return response.blob()
        })
        .then((result) => {
          resolve(result)
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  stdOrder () {
    const url = Config.apiurl + '/secure/stdOrder'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ email_address: store.state.auth.userinfo.user_email, order: store.state.order }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  saveOrder (order) {
    const url = Config.apiurl + '/secure/saveOrder'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ order: order }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  sendOrder () {
    const url = Config.apiurl + '/secure/sendOrder'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ email_address: store.state.auth.userinfo.user_email, order: store.state.order }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },

  saveSpareparts (cartOrder, details) {
    const url = Config.apiurl + '/secure/saveSpareparts'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ email_address: store.state.auth.userinfo.user_email, anacli: store.state.clidata.anacli, order: cartOrder, details: details }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  get_sparepartsOrders (codcli, dataStart, dataEnd) {
    const url = Config.apiurl + '/secure/get_sparepartsOrders'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('jwt'),
      body: JSON.stringify({ codcli: codcli, data_start: dataStart, data_end: dataEnd }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  // listaDownloads
  listaDownloads () {
    const url = Config.apiurl + '/secure/listaDownloads'
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: this.headers('jwt'),

    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          return this.handleResponse(response)
        })
        .then((result) => {
          resolve(this.handleResult(result))
        })
        .catch((error) => {
          this.handleError(error, url)
          reject(error)
        })
    })
  },
  download (filename) {
    const url = Config.apiurl + '/download'
    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: this.headers('erp'),
      body: JSON.stringify({ filename: filename }),
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          console.log('response', response)
          throw new Error(`${response.status} File Not Found`)
        }
        // /** se serve ottenere il nome dall'header verificare anche in php ->withHeader('Access-Control-Expose-Headers','Content-Disposition') */
        // const contentDisposition = response.headers.get('Content-Disposition')
        // var filename = 'downloaded_file'
        // if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
        //   const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        //   const matches = filenameRegex.exec(contentDisposition)
        //   if (matches !== null && matches[1]) {
        //     filename = matches[1].replace(/['"]/g, '')
        //   }
        // }
          return response.blob()
      })
      .then((result) => {
        console.log('filename ', filename)
          resolve({ blob: result, filename: filename })
      })
      .catch((error) => {
        this.handleError(error, url)
        reject(error)
      })
    })
  },
  // #################### Handler response and error ########################################################################
  handleResponse: function (response) {
    // console.log('handleResponse', response)
    var payload = response.json()
    if (response.status === 401) {
      store.commit('setSnack', { message: 'Response Err: ' + response.status + ' Type:' + response.type + ' # ' + response.statusText, color: '#c54747d4' })
      store.dispatch('logout')
      return
    }
    if (response.status !== 200 && !payload) {
      store.commit('setSnack', { message: 'Response Err: ' + response.status + ' Type:' + response.type + ' # ' + response.statusText, color: '#c54747d4' })
      return
    }
    return payload
  },
  handleResult: function (payload) {
    if (payload.error) {
      store.commit('setSnack', { message: 'Error ' + payload.error_code + ' ' + payload.error_reason, color: '#c54747d4' })
      if (payload.error_code === 90) {
        store.dispatch('logout')
      }
      //   return false
      throw new Error(JSON.stringify(payload))
    }
    return payload
  },
  handleError: function (error, url) {
    var errormsg = url + '<hr> General Error'
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      errormsg = JSON.stringify(error.response)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)
      errormsg = JSON.stringify(error.response)
    } else {
      // Something happened in setting up the request that triggered an Error

      try {
        var payload = JSON.parse(error.message)
        if (payload.error) {
          console.log('###payload Error', payload)
          errormsg = payload.error_reason
        }
      } catch (e) {
        console.log('### Error', url, error.message)
        errormsg = JSON.stringify(error.message)
      }
    }
    store.commit('setSnack', { message: url + '<hr>' + errormsg, color: '#c54747d4' })
  },
}
export default engine
